import React from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

const Label = styled.div`
  margin-right: 8px;
  font-weight: bold;
`;

const LabelRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-content: space-between;
`;

const Text = styled.div`
  margin-left: auto;
`;

const LabelRow = ({ label, text }) => (
  <LabelRowContainer>
    <Label>
      <FormattedMessage id={label} />
    </Label>
    <Text>{text}</Text>
  </LabelRowContainer>
);

LabelRow.propTypes = {
  label: PropTypes.string,
  text: PropTypes.string,
};

LabelRow.defaultProps = {
  label: 'Default',
  text: 'Default',
};

export default LabelRow;
